export default __webpack_public_path__ + "static/media/MC-3.5d1e4ca2.gif";